import service from "@/api/service";
import { SearchRequest } from "@/api/shop-push/request";
import { SearchResponse } from "@/api/shop-push/response";
import { GetResponse } from "@/api/shop-push/response";

/**
 * プッシュメッセージ店舗一覧・検索APIをコールします。
 *
 * @param searchRequest 検索のリクエストボディ
 * @return SearchResponse
 */
export async function search(searchRequest: SearchRequest) {
  const response = await service.post("/search-push-shop", searchRequest);
  return response.data as SearchResponse;
}

/**
 * プッシュメッセージ店舗情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get() {
  const response = await service.post("/get-push-shop ");
  return response.data as GetResponse;
}
